// extracted by mini-css-extract-plugin
module.exports = {"section":"core-engine_section__1l6OT","imgWrapper":"core-engine_imgWrapper__36dkG","carousel":"core-engine_carousel__3uSVP","item":"core-engine_item__2q8x_"};